export default "__VITE_ASSET__$8GcUE0F__"